import React, { useRef, useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import useToken from "./useToken";
import { Toast } from 'primereact/toast';
import SpinnerLoading from '../sampanganimation/SpinnerLoading';
import ValidToken from "./middleware/ValidToken";
import { useOtpPushListener } from "../../hooks/useOtpPushListener";

const OTPComponent = ({ length = 6, users, onResend, className = '' }) => {
    const inputRef = useRef(Array(length).fill(null));
    const [OTP, setOTP] = useState(Array(length).fill(''));
    const [otp, setOtp] = useState('');
    const [timeLeft, setTimeLeft] = useState(300);
    const [canResend, setCanResend] = useState(false);
    const [shake, setShake] = useState(false);
    const toast = useRef(null);
    const { token, setToken } = useToken();
    const navigate = useNavigate();

    // Cuma "dengerin" — gak daftarin device apapun di halaman ini
    const { receivedCode } = useOtpPushListener();

    // Kalau OTP kebetulan datang lewat push (device ini sudah pernah diaktifkan
    // sebelumnya), otomatis isikan ke form
    useEffect(() => {

        console.log(receivedCode);
        
        if (receivedCode) {
            setOTP(Array(receivedCode).fill(''));
        }
    }, [receivedCode]);

    // Timer countdown
    useEffect(() => {
        if (timeLeft <= 0) {
            setCanResend(true);
            return;
        }

        const timer = setInterval(() => {
            setTimeLeft((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [timeLeft]);

    const handleTextChange = (value, index) => {
        const input = value.replace(/\D/g, '');
        const newOTP = [...OTP];
        newOTP[index] = input;
        setOTP(newOTP);

        const fullOtp = newOTP.join('');
        setOtp(fullOtp);

        if (input && index < length - 1) {
            inputRef.current[index + 1]?.focus();
        }

        if (!input && index > 0) {
            inputRef.current[index - 1]?.focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace' && OTP[index] === '' && index > 0) {
            inputRef.current[index - 1]?.focus();
        }

        if (e.key === 'ArrowLeft' && index > 0) {
            inputRef.current[index - 1]?.focus();
        }

        if (e.key === 'ArrowRight' && index < length - 1) {
            inputRef.current[index + 1]?.focus();
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pasteData = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, length);

        if (pasteData.length === length) {
            const newOTP = pasteData.split('');
            setOTP(newOTP);
            setOtp(pasteData);

            // Focus last input
            inputRef.current[length - 1]?.focus();
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (otp.length !== length) {
            setShake(true);
            setTimeout(() => setShake(false), 500);
            return;
        }

        SpinnerLoading(true);

        axios
            .post(global.config.backend + "/api/otpvalidate", {
                user_id: users.id,
                otp: otp
            })
            .then((res) => {
                SpinnerLoading(false);

                if (res.data.status) {
                    setToken(res.data.data);
                    ValidToken().then((valid) => {
                        if (valid.status) {
                            if (valid.data.users[0].is_apel_leader == '1') {
                                navigate("/unit-kerja/Sekretariat?page=apel-pagi");
                            } else {
                                navigate('/daily-activity');
                            }
                        }
                    });
                } else {
                    setShake(true);
                    setTimeout(() => setShake(false), 500);

                    if (res.data.errors.length > 0) {
                        res.data.errors.map((item) => {
                            toast.current.show({ severity: 'warn', detail: item });
                        });
                    } else {
                        toast.current.show({ severity: 'warn', detail: res.data.massage });
                    }
                }
            })
            .catch((res) => {
                console.log(res);
                SpinnerLoading(false);
                setShake(true);
                setTimeout(() => setShake(false), 500);
                toast.current.show({ severity: 'warn', detail: 'Error connect to services' });
            });
    };

    const handleResendCode = (e) => {
        setTimeLeft(300);
        setCanResend(false);
        setOTP(Array(length).fill(''));
        setOtp('');
        onResend(e);
    };

    const formatTime = (seconds) => {
        const m = Math.floor(seconds / 60);
        const s = seconds % 60;
        return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
    };

    const animationStyles = `
        /* OTP Component Styles */
        .otp-container {
            width: 100%;
        }

        .otp-card {
            background: rgba(255, 255, 255, 0.95);
            backdrop-filter: blur(20px);
            border-radius: 24px;
            padding: 40px;
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
            border: 1px solid rgba(255, 255, 255, 0.3);
            transform: translateY(0);
            opacity: 1;
            transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .otp-card.card-enter {
            animation: cardEnter 0.6s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .otp-card.card-exit {
            opacity: 0;
            transform: translateY(30px);
        }

        .otp-card.shake {
            animation: shake 0.5s ease-in-out;
        }

        .otp-icon {
            width: 80px;
            height: 80px;
            margin: 0 auto 20px;
            background: linear-gradient(135deg, #04a, #002461);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 32px;
            color: white;
            box-shadow: 0 8px 25px rgba(4, 170, 255, 0.3);
        }

        .otp-inputs {
            display: flex;
            justify-content: center;
            gap: 12px;
            margin: 32px 0;
        }

        .otp-input-wrapper {
            position: relative;
        }

        .otp-input {
            width: 50px;
            height: 50px;
            border: 2px solid rgba(4, 170, 255, 0.2);
            border-radius: 12px;
            background: rgba(255, 255, 255, 0.9);
            text-align: center;
            font-size: 24px;
            font-weight: 600;
            color: #002461;
            transition: all 0.3s ease;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
        }

        .otp-input:focus {
            outline: none;
            border-color: #04a;
            transform: scale(1.05);
            box-shadow: 0 8px 25px rgba(4, 170, 255, 0.2);
        }

        .otp-input.filled {
            border-color: #04a;
            background: rgba(4, 170, 255, 0.05);
        }

        .otp-separator {
            position: absolute;
            right: -6px;
            top: 50%;
            transform: translateY(-50%);
            width: 4px;
            height: 4px;
            background: #04a;
            border-radius: 50%;
            opacity: 0.5;
        }

        .verify-btn {
            margin-top: 32px;
        }

        .resend-section {
            text-align: center;
            margin-bottom: 20px;
        }

        .resend-btn {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            background: none;
            border: none;
            color: #04a;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            padding: 8px 16px;
            border-radius: 8px;
            transition: all 0.3s ease;
        }

        .resend-btn:hover {
            background: rgba(4, 170, 255, 0.1);
            transform: translateY(-2px);
        }

        .resend-btn i {
            animation: spin 2s linear infinite;
        }

        .timer {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            color: #666;
            font-size: 14px;
        }

        .timer i {
            color: #04a;
        }

        .timer strong {
            color: #002461;
            font-weight: 600;
        }

        /* Animations */
        @keyframes shake {
            0%, 100% {
                transform: translateX(0);
            }
            10%, 30%, 50%, 70%, 90% {
                transform: translateX(-5px);
            }
            20%, 40%, 60%, 80% {
                transform: translateX(5px);
            }
        }

        @keyframes spin {
            0% {
                transform: rotate(0deg);
            }
            100% {
                transform: rotate(360deg);
            }
        }

        /* Responsive OTP */
        @media (max-width: 768px) {
            .otp-input {
                width: 50px;
                height: 50px;
                font-size: 20px;
            }

            .otp-inputs {
                gap: 8px;
            }
        }

        @media (max-width: 480px) {
            .otp-input {
                width: 40px;
                height: 40px;
                font-size: 18px;
            }

            .otp-inputs {
                gap: 6px;
            }
        }
    `;

    return (
        <>
        <div className={`otp-container ${className}`}>
            <Toast ref={toast} />
            <div className={`otp-card ${shake ? 'shake' : ''}`}>
                <div className="card-header">
                    <h2 className="card-title">Verifikasi OTP</h2>
                    <p className="card-subtitle">
                        Masukkan 6-digit kode yang telah terkirim
                    </p>
                </div>

                <form className="otp-form" onSubmit={handleSubmit} onPaste={handlePaste}>
                    <div className="form-group">
                        <div className="otp-inputs">
                            {Array.from({ length }, (_, index) => (
                                <div key={index} className="otp-input-wrapper">
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        maxLength={1}
                                        autoFocus={index === 0}
                                        value={OTP[index]}
                                        onChange={(e) => handleTextChange(e.target.value, index)}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                        onFocus={(e) => e.target.select()}
                                        ref={(ref) => (inputRef.current[index] = ref)}
                                        className={`otp-input ${OTP[index] ? 'filled' : ''}`}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="form-group">
                        <button type="submit" className="modern-btn primary verify-btn">
                            <span>Verifikasi</span>
                            <i className="ti-check"></i>
                        </button>
                    </div>
                </form>

                <div className="card-footer">
                    <div className="resend-section">
                        {canResend ? (
                            <button
                                className="resend-btn"
                                onClick={handleResendCode}
                            >
                                <i className="ti-reload"></i>
                                <span>Kirim Ulang OTP</span>
                            </button>
                        ) : (
                            <div className="timer">
                                <i className="ti-timer"></i>
                                <span>Kirim ulang dalam <strong>{formatTime(timeLeft)}</strong></span>
                            </div>
                        )}
                    </div>

                    <p className="copyright mb-0">
                        {new Date().getFullYear()} &copy; Dinas Kominfo Sampang
                    </p>
                </div>
            </div>
        </div>
        <style>{animationStyles}</style>
        </>
    );
};

export default OTPComponent;